import { Injectable } from '@angular/core';
import { PropertyBookletEquipmentType } from './property-booklet-equipment-card.component';

@Injectable()
export class PropertyBookletEquipmentService {
  public static getTitle(type: PropertyBookletEquipmentType): string {
    let title = '';
    switch (type) {
      case PropertyBookletEquipmentType.heating:
        title = 'Chauffage';
        break;
      case PropertyBookletEquipmentType.cooling:
        title = 'Refroidissement';
        break;
      case PropertyBookletEquipmentType.hotWater:
        title = "Production d'eau chaude sanitaire";
        break;
      case PropertyBookletEquipmentType.ventilation:
        title = 'Ventilation';
        break;
      case PropertyBookletEquipmentType.network:
        title = 'Réseau de chaleur ou de froid';
        break;
      case PropertyBookletEquipmentType.heatingMaintenance:
        title = 'Entretien du chauffage';
        break;
      default:
        console.error('PropertyBookletEquipmentService.getTitle(): Undefined title');
        break;
    }
    return title;
  }

  public static getSummary(type: PropertyBookletEquipmentType): string {
    let title = 'Ajoutez la fiche produit et la notice du ';
    switch (type) {
      case PropertyBookletEquipmentType.heating:
        title += 'système de chauffage';
        break;
      case PropertyBookletEquipmentType.cooling:
        title += 'système de refroidissement';
        break;
      case PropertyBookletEquipmentType.hotWater:
        title += "système de production d'eau chaude sanitaire";
        break;
      case PropertyBookletEquipmentType.ventilation:
        title += 'système de ventilation';
        break;
      case PropertyBookletEquipmentType.network:
        title = 'Indiquez le poste de livraison du réseau de chaleur ou de froid';
        break;
      case PropertyBookletEquipmentType.heatingMaintenance:
        title = "Ajoutez les informations d'entretien du chauffage";
        break;
      default:
        console.error('PropertyBookletEquipmentService.getSummary(): Undefined summary');
        break;
    }
    return title;
  }
}
